const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const UpdateSkill = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_FIELD_STAFFF':
    return { ...INITIAL_STATE, data: action.data }
  case 'UPDATE_FIELD_STAFFF_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default UpdateSkill;